<script setup lang="ts">
import { useHead } from '@unhead/vue'
import { settings, PATHS } from '@/content'
import { baseHead } from '@/lib/seo'

useHead(() => ({
  ...baseHead({
    title: 'Merci pour votre demande - Les Ateliers du Terras',
    description: 'Votre demande a bien été envoyée. Notre équipe vous recontacte rapidement.',
    canonical: PATHS.merci,
    index: false,
  }),
}))
</script>

<template>
  <section class="merci">
    <div class="container merci__in">
      <div class="merci__badge" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="46" height="46" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>
      <h1>Merci, votre demande est bien partie !</h1>
      <p>
        Notre équipe vous recontacte au plus vite pour échanger sur votre projet. Pour une demande
        urgente, appelez-nous directement :
      </p>
      <div class="merci__phones">
        <a v-for="p in settings.phones" :key="p.tel" :href="`tel:${p.tel}`" class="btn btn--primary">
          {{ p.display }} ({{ p.label }})
        </a>
      </div>
      <router-link to="/" class="merci__home">Retour à l'accueil</router-link>
    </div>
  </section>
</template>

<style scoped>
.merci {
  padding: 80px 0;
  text-align: center;
}
.merci__in {
  max-width: 640px;
}
.merci__badge {
  width: 84px;
  height: 84px;
  border-radius: 50%;
  background: var(--green);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.merci__phones {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin: 24px 0;
}
.merci__home {
  color: var(--green-dark);
  font-weight: 700;
}
</style>
